import React from 'react';
import { View, FlatList, RefreshControl, Text } from 'react-native';
import { connect } from 'react-redux';

import Colors from "../../constants/Colors";
import get from "../../api/methods/get";
import {QUERY_DELIVERABLES_BY_JOURNEY} from "./api/deliveryEndpoints";
import JourneyDeliveryComponent from "./JourneyDeliveryComponent";
import NavBar from "../../components/NavBar";
import {SpinnerControl} from "../../components";

class JourneyDeliveries extends React.Component {

    static navigationOptions = ({navigation}) => {
        return {
            title: 'Aplicações',
        }
    };

    state = {
        deliveries: [],
        isFetching: false,
    }

    fetchDeliveries = async () => {
        if (this.state.isFetching) return;
        this.setState({ isFetching: true });

        try {

            let result = await get(QUERY_DELIVERABLES_BY_JOURNEY(this.props.journeyId));
            let json = await result.json();

            //Filtra as aplicações que são do usuário!
            const items = json.data.Items.filter(item => item.GSI1PK !== this.props.userId)

            this.setState({ deliveries: items })
        } catch (e) {
            console.log(e);
        }

        this.setState({ isFetching: false });
    }

    componentDidMount() {
        this.fetchDeliveries();
    }

    render() {
        return (
            <NavBar title={"Aplicações da Jornada"}>

                <SpinnerControl
                    isFetching={this.state.isFetching}
                    text={"Carregando aplicações!"}
                />

                {
                    (this.state.isFetching === false && this.state.deliveries.length === 0) &&
                        <Text style={{ fontSize: 16, textAlign: 'center', color: Colors.fontColorOnBackground, margin: 20 }}>
                            Ainda não foi enviada nenhuma Aplicação. Iremos te avisar assim que tivermos uma aplicação para ser revisada!
                        </Text>
                }

                <FlatList
                    contentContainerStyle={{ padding: 20, width: 600 }}
                    data={this.state.deliveries}
                    renderItem={({item}) => {
                        return <JourneyDeliveryComponent data={item} />
                    }}
                    refreshControl={
                        <RefreshControl
                            refreshing={this.state.isFetching}
                            onRefresh={() => this.fetchDeliveries()}
                            colors={[Colors.spinnerColor]}
                            title={'Carregando entregas!'}
                        />
                    }
                    keyExtractor={item => item.SK.toString()}
                />

            </NavBar>
        )
    }

}

const mapStateToProps = state => {
    return {
        userId: state.user.userId,
        journeyId: state.journey.currentJourney.id
    }
}

export default connect(mapStateToProps)(JourneyDeliveries);
